/**
 * connection.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Observable } from "rxjs/Rx";
import { Message } from "../messages/general/";

export abstract class Connection<T> {
  public dead : boolean = false;

  public incoming : Observable<T>;

  constructor ()
  {
    // Nothing
  }

  public abstract close () : void;

  public abstract send (message : T) : void;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/connection/connection.ts